module.exports = __webpack_public_path__ + "img/image-lost-son.45e665dc.svg";